import { render, staticRenderFns } from "./InsertWells96.vue?vue&type=template&id=4b26498e&scoped=true&"
import script from "./InsertWells96.vue?vue&type=script&lang=js&"
export * from "./InsertWells96.vue?vue&type=script&lang=js&"
import style0 from "./InsertWells96.vue?vue&type=style&index=0&id=4b26498e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b26498e",
  null
  
)

export default component.exports